import { Button } from '@material-ui/core';
import {
  ArrowDropDownRounded,
  ArrowDropUpRounded,
  DeleteOutlineRounded,
} from '@material-ui/icons';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components/macro';
import { dndConstants } from 'store/constants';
import CommonOrSplitBox from './CommonOrSplitBox';

import { useSelector, useDispatch } from 'react-redux';
import { commonPagesWithThumbnailSelector } from 'store/selectors/cur-bookings-attachments.selector';
import DestThumbnailList from './DestThumbnailList';
import { commonPagesActions } from 'store/actions';

const title = 'Global Common';
const descriptionTexts = [
  {
    text: '(prepend to every output file in every booking when drag',
  },
  { text: 'file', highlighted: true },
  { text: 'or' },
  { text: 'page', highlighted: true },
  { text: 'to this)' },
];
const dndItemType = dndConstants.GLOBAL_COMMON;
const GlobalCommon = () => {
  const dispatch = useDispatch();
  const [isShowMore, setIsShowMore] = useState(true);
  const handleToggleIsShowMore = (e) => {
    setIsShowMore(!isShowMore);
  };
  const handleClearGlobalCommon = (e) => {
    dispatch(commonPagesActions.clear());
  };
  const commonPagesWithThumbnail = useSelector(
    commonPagesWithThumbnailSelector,
  );
  const hasCommonPages = useMemo(
    () =>
      commonPagesWithThumbnail && commonPagesWithThumbnail.length > 0,
    [commonPagesWithThumbnail],
  );

  return (
    <SGlobalWrapper>
      <CommonOrSplitBox
        title={title}
        // description={description}
        descriptionTexts={descriptionTexts}
        dndItemType={dndItemType}
      />
      <SPages>
        {hasCommonPages ? (
          <SThumbnailList className={isShowMore ? 'on-expand' : ''}>
            <DestThumbnailList
              thumbnails={commonPagesWithThumbnail}
            />
          </SThumbnailList>
        ) : (
          <SNoThumbnails>No common pages</SNoThumbnails>
        )}
        {/* only show show less/more if has any common pages */}
        {hasCommonPages && (
          <SShowLessMore>
            <Button
              size="small"
              color="primary"
              variant="outlined"
              startIcon={<DeleteOutlineRounded />}
              onClick={handleClearGlobalCommon}
            >
              Clear
            </Button>
            <Button
              size="small"
              color="primary"
              variant="outlined"
              startIcon={
                isShowMore ? (
                  <ArrowDropUpRounded />
                ) : (
                  <ArrowDropDownRounded />
                )
              }
              onClick={handleToggleIsShowMore}
            >
              {isShowMore ? `Show Less` : `Show More`}
            </Button>
          </SShowLessMore>
        )}
      </SPages>
    </SGlobalWrapper>
  );
};

export default GlobalCommon;

const SGlobalWrapper = styled.div`
  border-bottom: 1px dashed
    ${(props) => props.theme.palette.common.borderGrey};
  margin-bottom: 0.5rem;
`;
const SPages = styled.div``;
const SShowLessMore = styled.div`
  text-align: right;
  & > .MuiButton-root + .MuiButton-root {
    margin-left: 5px;
  }
  margin-bottom: 5px;
`;
const SThumbnailList = styled.div.attrs((props: any) => ({
  className: props.className,
}))`
  &.on-expand {
    height: fit-content; // doesn't work with transition
    transition: height 0.3s ease-out;
  }
  &:not(.on-expand) {
    height: 0;
    transition: height 0.3s ease-in;
  }
  overflow-y: hidden;
`;
const SNoThumbnails = styled.div`
  text-align: center;
  font-size: ${(props) => props.theme.typography.fontSize.body};
  line-height: ${(props) => props.theme.typography.lineHeight.title};
  color: ${(props) => props.theme.palette.text.secondary};
  background: ${(props) => props.theme.palette.grey[50]};
`;
